import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ImagePreloadingService {
	constructor(private http: HttpClient) {}

	preloadImages(imageData: any) {
		const imageUrls = [];

		if (imageData.desktopPrimary) {
			imageUrls.push(imageData.desktopPrimary.src);
		}
		if (imageData.desktopSecondary) {
			imageUrls.push(imageData.desktopSecondary.src);
		}
		if (imageData.desktopTertiary) {
			imageUrls.push(imageData.desktopTertiary.src);
		}
		if (imageData.mobilePrimary) {
			imageUrls.push(imageData.mobilePrimary.src);
		}
		if (imageData.mobileSecondary) {
			imageUrls.push(imageData.mobileSecondary.src);
		}

		for (const imageUrl of imageUrls) {
			this.http.get(imageUrl, { responseType: 'blob' }).subscribe(response => {
				const blob = new Blob([response], { type: response.type });
				const image = new Image();
				image.src = URL.createObjectURL(blob);
				image.onload = () => {
					URL.revokeObjectURL(image.src);
				};
			});
		}
	}
}
